import * as React from 'react'

import { AppContext } from "../../../Context/AppContext"

import { ReactElement, useContext, useEffect, useState } from 'react'
import { postier } from './postier'
import "./style.scss"
import { Search } from '../../Search'

export interface Client {
    code: string,
    address: string,
    database: string,
    Usersapp: string[]
    name: string
    port: number
}

export function Client(): ReactElement {
    const { token, role, client, setErrors } = useContext(AppContext)

    const [clientInfo, setClient] = useState<Client>({code: '', address: '', database: '', Usersapp: [], name: '', port: 0})
    const [filteredList, setFilteredList] = useState<string[]>([]);
    const [isOptician, setIsOptician] = useState<boolean>(false)

    useEffect(() => {
        postier.getClient(token, client.split(':')[3], setClient, setErrors)
        
        fetch('/data/clients').then(res => res.json()).then(data => {
            setIsOptician(data.some(el => el.name === client.split(":")[0]))
        })
    }, [client]);

    useEffect(() => {
        setFilteredList(clientInfo.Usersapp);
    }, [clientInfo.Usersapp]);

    return (
        <div className="site">
            <h2>{clientInfo.name}</h2>
            <label>Code  </label><div className="label"> {clientInfo.code}</div>
            <label>Adresse serveur </label><div className="label"> {clientInfo.address}</div>
            <label>Nom base de données </label><div className="label"> {clientInfo.database}</div>
            <label>Opticien</label><div className="label"> {isOptician ? "Oui" : "Non"}</div>
            {role === 'SuperAdmin' && 
                <>
                    <label>Utilisateurs</label>
                    <div className="users">
                        <Search needle={clientInfo.Usersapp} setFilteredList={setFilteredList} searchParam={""} style={{width: '90%'}} />
                        {filteredList.map(user => {
                            return <div>{user}&nbsp;</div>
                        })}
                    </div>
                </>
            }
        </div>
    )
}

